<template>
    <cic-popup
        id="edit_facebook_account"
        :title="item.lAccountID ? $t('Edit Facebook Account') : $t('New Facebook Account')"
        :saveable="$store.hasRight('EDIT_ACCESS_TYPE_16')"
        @blur="$emit('blur')"
        @input="validate"
    >
        <div class="item-form">
            <el-alert
                v-if="item.szUserID !== null"
                id="update-alert"
                :closable="false"
                :title="$t('This legacy account should be updated')"
                type="warning"
                show-icon
                center
            />
            <ul>
                <li class="form-label-first">{{ $t('Page Name') }}:</li>
                <li>
                    <cic-textbox
                        id="accountName"
                        :value="item.szAccountName"
                        :class="{ highlight: accountNameInvalid }"
                        :placeholder="$t('Label for Facebook account')"
                        @input="(val) => updateFieldValue('szAccountName', val)"
                    />
                </li>

                <li class="form-label">{{ $t('Page ID') }}:</li>
                <li>
                    <cic-textbox
                        id="pageId"
                        :value="item.szPageID"
                        :class="{ highlight: pageIdInvalid }"
                        :placeholder="$t('Facebook page ID')"
                        :enabled="!item.lAccountID"
                        @input="(val) => updateFieldValue('szPageID', val)"
                    />
                </li>

                <li class="form-label">{{ $t('Facebook') }}:</li>
                <li>
                    <cic-checkbox
                        :value="item.bEnableFacebookPublic"
                        @input="(val) => updateFieldValue('bEnableFacebookPublic', val)"
                    />
                </li>

                <li class="form-label">{{ $t('Messenger') }}:</li>
                <li>
                    <cic-checkbox
                        :value="item.bEnableFacebookDirect"
                        @input="(val) => updateFieldValue('bEnableFacebookDirect', val)"
                    />
                </li>

                <template v-if="item.bEnableFacebookDirect">
                    <li class="form-label">{{ $t('Timeout Message') }}:</li>
                    <li>
                        <cic-textarea
                            id="facebook_timeOutMessage"
                            :value="item.szTimeOutMessage"
                            :autosize="true"
                            :maxlength="2000"
                            @input="(val) => updateFieldValue('szTimeOutMessage', val)"
                        />
                    </li>
                </template>

                <li class="form-label">{{ $t('Instagram') }}:</li>
                <li>
                    <cic-checkbox
                        :value="item.bEnableInstagramPublic"
                        @input="(val) => updateFieldValue('bEnableInstagramPublic', val)"
                    />
                </li>

                <li class="form-label">{{ $t('Instagram Direct') }}:</li>
                <li>
                    <cic-checkbox
                        :value="item.bEnableInstagramDirect"
                        @input="(val) => updateFieldValue('bEnableInstagramDirect', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import { ElAlert } from 'element-plus';
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import CicTextarea from '@/components/inputs/CicTextarea';

    export default {
        name: 'EditFacebookAccount',
        components: {
            CicTextbox,
            CicCheckbox,
            CicPopup,
            CicTextarea,
            'el-alert': ElAlert,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                accountNameInvalid: false,
                pageIdInvalid: false,
            };
        },
        methods: {
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },

            validate() {
                this.accountNameInvalid = this.item.szAccountName.trim() === '';
                this.pageIdInvalid = this.item.szPageID.trim() === '';

                if (this.accountNameInvalid || this.pageIdInvalid) {
                    return;
                }

                const reg = /^\d+$/;

                if (!reg.test(this.item.szPageID.trim())) {
                    alert(this.$t('Values for Page ID must be numeric'));
                    return;
                }

                if (
                    !(
                        this.item.bEnableFacebookPublic ||
                        this.item.bEnableFacebookDirect ||
                        this.item.bEnableInstagramDirect ||
                        this.item.bEnableInstagramPublic
                    )
                ) {
                    alert(this.$t('Please select at least one access type'));
                    return;
                }

                this.$emit('input');
            },
        },
    };
</script>
